import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PagedCollectionResponse } from "src/app/models/http/page-collection-response.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";
import { CompanyShoeInsoles } from "src/app/models/company-shoe-insoles.model";

@Injectable({
    providedIn: 'root'
  })
  export class CompanyShoeInsolesService extends BaseService {

    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees/[employee-id]/company-shoe-insoles');
    }


  getShoeInsoles(params?: HttpParams) {
    return this.http.get<PagedCollectionResponse<CompanyShoeInsoles>>(`${this.apiUrl}`, { params: params });
  }

  getShoeInsoleDetails(companyShoeInsoleId: number, params?: HttpParams) {
    return this.http.get<CompanyShoeInsoles>(`${this.apiUrl}/${companyShoeInsoleId}`, { params: params });
  }

  getShoeInsoleBrands(params?: HttpParams) {
    return this.http.get<string[]>(`${this.apiUrl}/brands`, { params: params });
  }

}
